<!-- <p>create-asset-distribution works!</p> -->
<app-dialog-header *ngIf="!viewing && !editing" headerText="Create Asset Model: {{asset.Name}} - {{asset.Description}}"
    headerIcon="auto_awesome" (onCloseClick)="onCancelClick()"></app-dialog-header>
<app-dialog-header *ngIf="viewing && !editing" headerText="View Asset Model: {{asset.Name}} - {{asset.Description}}"
    headerIcon="auto_awesome" (onCloseClick)="onCancelClick()"></app-dialog-header>
<app-dialog-header *ngIf="!viewing && editing" headerText="Edit Asset Model: {{asset.Name}} - {{asset.Description}}"
    headerIcon="auto_awesome" (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div class="dialog-content" *ngIf="asset">
        <div class="noshrink alignRow alignColumn">
            <div class="alignRow">
                <mat-icon *ngIf="!viewing && !editing && manualSelected" matTooltip="Navigate Backwards"
                    (click)="navigateByDuration(false)">chevron_left</mat-icon>
                <mat-icon *ngIf="viewing || editing || !manualSelected"
                    style="color: lightgray;">chevron_left</mat-icon>
                <mat-chip-set aria-label="Time selection" class="chip-set"
                    [disabled]="viewing || editing || !manualSelected">
                    <app-duration-selector [(duration)]="strDuration"
                        (durationChange)="selectTime($event)"></app-duration-selector>
                    <!-- <mat-chip *ngFor="let duration of chipDurations"
                        [ngStyle]="{'background-color': strDuration === duration.time ? 'lightblue' : ''}"
                        (click)="selectTime(duration.time)" matTooltip={{duration.toolTip}}>
                        {{duration.text}}
                    </mat-chip> -->
                </mat-chip-set>
                <mat-icon *ngIf="!viewing && !editing && manualSelected" matTooltip="Navigate Forwards"
                    (click)="navigateByDuration(true)">chevron_right</mat-icon>
                <mat-icon *ngIf="viewing || editing || !manualSelected"
                    style="color: lightgray;">chevron_right</mat-icon>
                <span *ngIf="!viewing && !editing && manualSelected" mat-icon-button [matMenuTriggerFor]="timeMenu"
                    #timeTrigger="matMenuTrigger" style="margin-left: 10px;" class="alignRow" matTooltip="Date Range">
                    <mat-icon>access_time</mat-icon>
                    <mat-menu #timeMenu="matMenu">
                        <div style="margin: 1em;">
                            <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                                [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                        </div>
                    </mat-menu>
                </span>
                <span *ngIf="viewing || editing || !manualSelected" style="margin-left: 10px;" class="alignRow">
                    <mat-icon style="color: lightgray;">access_time</mat-icon>
                </span>
                <button style="margin-left: 10px;" mat-raised-button (click)="selectEntireRange()"
                    [disabled]="viewing || editing || !manualSelected">
                    <span>Select Entire Range</span>
                </button>
                <button style="margin-left: 10px;" mat-raised-button *ngIf="viewing"
                    (click)="openTestDistributionWindow()">
                    <span>Test Model</span>
                    <mat-icon>science</mat-icon>
                </button>
                <button style="margin-left: 10px;" mat-raised-button *ngIf="viewing" (click)="recreateModel()">
                    <span>Edit Model</span>
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
            <span *ngIf="visibleStartDate && visibleEndDate" class="hideoverflow"
                style="font-weight: bolder; font-size: larger;">({{getShortDate(visibleStartDate)}}
                - {{getShortDate(visibleEndDate)}})</span>
        </div>
        <div class="chart-container">
            <!-- height="100%" width="100%" -->
            <ejs-chart style="height: 100%; width: 100%;" #myDistChart id="myDistChart" [primaryXAxis]='sensorXAxis'
                [zoomSettings]="zoomSettings" [legendSettings]='legend' [tooltip]='tooltipSettings'
                [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings" [titleStyle]="titleStyle"
                [palettes]='palette' (onZooming)="chartMouseDown($event)" (zoomComplete)="zoomComplete($event)"
                (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)" (chartMouseDown)="checkClick($event)"
                [selectionMode]='selectionMode' (resized)="chartresized($event)" (chartMouseMove)="chartHover($event)"
                (tooltipRender)="onTooltipRender($event)" (dragComplete)="onSelectionComplete($event)"
                [selectedDataIndexes]="selectedData">
            </ejs-chart>
        </div>
        <div class="local-spinner" *ngIf="spinner">
            <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                [attr.x-contenttype]="'image/gif'" alt="Loading..." />
        </div>
        <div class="tab-div alignColumn">
            <div>
                <button mat-raised-button [ngStyle]="{'border': manualSelected ? '2px solid var(--prism-blue)' : ''}"
                    (click)="changeSelection(true)" [disabled]="viewing || editing">
                    <span>Manual</span>
                </button>
                <button mat-raised-button [ngStyle]="{'border': !manualSelected ? '2px solid var(--prism-blue)' : ''}"
                    (click)="changeSelection(false)" [disabled]="viewing || editing">
                    <span>Automatic</span>
                </button>
            </div>
        </div>
        <div class="content">
            <div *ngIf="manualSelected then manual else automatic"></div>
            <form [formGroup]="dialogForm" autocomplete="off">
                <div class="other-settings">
                    <div class="switch-div">
                        <mat-slide-toggle color="primary" [checked]="onlyDisplayCharted"
                            (change)="filterShowOnChart($event.checked)" [disabled]="editing || viewing">
                        </mat-slide-toggle>
                        <span>Charted Datapoints Only</span>
                    </div>
                    <div class="datapoint-box">
                        <ejs-multiselect #datapointBox style="max-height: 7vh; overflow-y: auto;" mode='Box'
                            [fields]='datapointFields' placeholder="Choose DataPoints to Include" [showSelectAll]='true'
                            formControlName="datapoints" [dataSource]="dataPoints"
                            (change)="datapointSelected($event)"></ejs-multiselect>
                    </div>
                    <span class="alignRow" style="margin: auto;">
                        <span>Tolerance (1 - 5)</span>
                        <mat-icon style="cursor: pointer; margin-left: 5px;"
                            [matMenuTriggerFor]="toleranceHelp">help</mat-icon>
                        <mat-menu #toleranceHelp>
                            <div style="padding: 0.5em;">
                                <span>The Tolerance of a model defines how far the testing data must stray from the
                                    model's training data before an event is created.<br><br></span>
                                <span>The higher the Tolerance value, the more abnormal the testing data must be to
                                    create an event. So with a higher value events will be created less
                                    often.<br></span>
                            </div>
                        </mat-menu>
                    </span>
                    <ejs-numerictextbox [step]="1" cssClass="e-custom" [min]="1" [max]="5" formControlName="tolerance">
                    </ejs-numerictextbox>
                    <span class="alignRow" style="margin: auto;">
                        <span>Sensitivity (10 - 90)</span>
                        <mat-icon style="cursor: pointer; margin-left: 5px;"
                            [matMenuTriggerFor]="sensitivityHelp">help</mat-icon>
                        <mat-menu #sensitivityHelp>
                            <div style="padding: 0.5em;">
                                <span>The Sensitivity of a model defines how much of the testing data needs to exceed
                                    the Tolerance value before an event is created.<br><br></span>
                                <span>The higher the Sensitivity value, the less abnormal testing data will be needed to
                                    create an event. So with a higher value events will be created more
                                    often.<br><br></span>
                                <span>With a Sensitivity of 50.0, the average of the testing data will be
                                    used.<br></span>
                            </div>
                        </mat-menu>
                    </span>
                    <ejs-numerictextbox [step]="1" cssClass="e-custom" [min]="10" [max]="90"
                        formControlName="sensitivity">
                    </ejs-numerictextbox>
                    <span>Chosen Model Range</span>
                    <span *ngIf="!existingDistribution" class="manual alignColumn">{{getDistributionRange()}}</span>
                    <span *ngIf="existingDistribution"
                        class="manual alignColumn">{{convertEpoch(existingDistribution.StartPoint)}} -
                        {{convertEpoch(existingDistribution.EndPoint)}}</span>
                    <div class="form-div" style="padding-left: 0px; padding-right: 0px;">
                        <span>Samples in Range</span>
                        <span *ngIf="!existingDistribution" class="manual alignColumn">{{getTotalPoints()}}</span>
                        <span *ngIf="existingDistribution && existingDistValues"
                            class="manual alignColumn">{{(existingDistValues.length > 0) ?
                            existingDistValues.length * numPlottedDatapoints : ""}}</span>
                    </div>
                    <div class="form-div" style="padding-right: 0px;">
                        <span>Range Length (Days)</span>
                        <span *ngIf="!existingDistribution" class="manual alignColumn">{{getWidthInDays()}}</span>
                        <span *ngIf="existingDistribution && existingDistValues"
                            class="manual alignColumn">{{(existingDistValues.length > 0) ?
                            ((existingDistValues[existingDistValues.length-1].timestamp -
                            existingDistValues[0].timestamp) /
                            (1000 * 60 * 60 * 24)).toFixed(2) : ""}}</span>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="dialogForm.value"
            [disabled]="dialogForm.invalid || !dialogForm.dirty || noOkay || viewing">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</div>

<ng-template #automatic>
    <div class="alignColumn" style="width: 100%;">
        <span style="font-size: larger; font-weight: bolder;" class="alignRow">Automatic Model
            Settings
            <mat-icon style="cursor: pointer; margin-left: 5px;" [matMenuTriggerFor]="autoHelp">help</mat-icon>
        </span>
        <mat-menu #autoHelp>
            <div style="padding: 0.5em;">
                <span>Check 'Generate Models Automatically' to allow the system to automatically choose historical data
                    to be
                    treated as "good data". The "good data" is what the model will be trained on.<br><br></span>
                <span>The Model Timespan option controls the number of days of data that is chosen.<br><br></span>
                <span>The Recreation Frequency controls the number of days that must pass before a new model is created
                    automatically.<br><br></span>
                <span>The Overlap Period option controls the number of days of overlap between each model.<br></span>
            </div>
        </mat-menu>
        <form [formGroup]="dialogForm" autocomplete="off">
            <div class="automatic alignRow">
                <div class="switch-div">
                    <mat-slide-toggle color="primary" formControlName="isAutomatic" [checked]="automaticSelected"
                        (change)="toggleAutomatic($event)"></mat-slide-toggle>
                    <span class="toolbar-spacer"></span>
                    <span>Generate Models Automatically</span>
                </div>
                <div class="form-div alignRow">
                    <span>Model Timespan</span>
                    <ejs-numerictextbox [step]="1" formControlName="automaticWindowWidth" cssClass="e-custom" [min]="14"
                        [max]="90" (change)="getAutomaticData($event.value)">
                    </ejs-numerictextbox>
                </div>
                <div class="form-div alignRow">
                    <span>Recreation Frequency</span>
                    <ejs-numerictextbox [step]="1" formControlName="recreationFrequency" cssClass="e-custom" [min]="7"
                        [max]="90">
                    </ejs-numerictextbox>
                </div>
                <div class="form-div alignRow">
                    <span>Overlap Period</span>
                    <ejs-numerictextbox [step]="1" formControlName="overlapPeriod" cssClass="e-custom" [min]="0"
                        [max]="14">
                    </ejs-numerictextbox>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #manual>
    <div class="alignColumn" style="width: 100%;">
        <div class="alignColumn" style="width: 100%;">
            <span style="font-size: larger; font-weight: bolder;" class="alignRow">Manual Model
                Settings
                <mat-icon style="cursor: pointer; margin-left: 5px;" [matMenuTriggerFor]="manualHelp">help</mat-icon>
            </span>
            <mat-menu #manualHelp>
                <div style="padding: 0.5em;">
                    <span>Use the graph controls to display a trend that contains the data you want to select,
                        drag to select a period of "good data". The "good data" is what the model will be trained
                        on.<br><br></span>
                    <span>Only the Datapoints currently shown on the graph will be included, use the switch to
                        toggle between all Datapoints or just charted Datapoints.<br><br></span>
                    <span>You can choose to be sent a reminder to update the "good data" selection
                        below.<br></span>
                </div>
            </mat-menu>
        </div>
        <form [formGroup]="dialogForm" autocomplete="off">
            <div class="manual-options alignRow">
                <div class="switch-div">
                    <mat-slide-toggle color="primary" formControlName="remind" [checked]="remindSelected"
                        (change)="toggleRemind($event)"></mat-slide-toggle>
                    <span class="toolbar-spacer"></span>
                    <span>Remind Me</span>
                </div>
                <div class="form-div alignRow">
                    <span>Remind After (Days)</span>
                    <ejs-numerictextbox [step]="1" formControlName="remindAfter" cssClass="e-custom" [min]="14"
                        [max]="365">
                    </ejs-numerictextbox>
                </div>
            </div>
        </form>
    </div>
</ng-template>